



































































import { Component, Vue, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import UserInterface from "@/types/app/IUser";
import router from "../router";
import Endpoint from "@/utils/endpoint";
import Credential from "@/utils/credential";
import Auth from "@/plugins/auth";
import qs from "qs";
import * as Sentry from "@sentry/browser";

const namespace = "auth";

interface ServerResponse {
  access_token: object;
}

interface UserLogin {
  name: string;
  password: string;
}

@Component({})
export default class Customers extends Vue {
  public auth = new Auth();
  private endpoint = new Endpoint();
  private credentials = new Credential();

  errorLogin = false;
  loading = false;
  user: UserLogin = { name: "", password: "" };
  requiredRules: Array<any> = [
    (v: string) => {
      return !!v || "Required field";
    },
  ];

  @Action("setUser", { namespace }) setUser: any;
  @Action("disconnectToken", { namespace }) disconnectToken: any;

  created() {
    this.disconnectToken();
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  public login(): void {
    try {
      if (this.form) {
        this.loading = true;

        const data = {
          username: this.user.name,
          password: this.user.password,
          grant_type: this.credentials.credential.grantType,
          scope: this.credentials.credential.scope,
          client_id: this.credentials.credential.clientId,
          client_secret: this.credentials.credential.clientSecret,
        };

        this.$http
          .post(this.endpoint.login, qs.stringify(data), {
            headers: {
              "content-type": "application/x-www-form-urlencoded",
            },
          })
          .then((res: any) => {
            if (res == undefined) {
              this.loading = false;
              this.errorLogin = true;
            } else {
              this.errorLogin = false;
              this.auth.login(res.access_token, res.refresh_token);
              const user = this.auth.getUserDataFromToken();
              if (user.role.includes("admin") || user.role.includes("lcm")) {
                Sentry.setUser({ email: user.email, id: user.id });
                this.setUser({
                  username: user.preferred_username,
                  email: user.email,
                  isAdmin: user.role.includes("admin"),
                  isLCM: user.role.includes("admin") || user.role.includes("lcm"),
                  isLogged: true,
                });
                localStorage.setItem(`store-${process.env.NODE_ENV}`, "");
                this.loading = false;
                this.$router.push({ path: "/" }).then(() => {
                  this.$router.go(0);
                });
              } else {
                this.loading = false;
                this.errorLogin = true;
              }
            }
          })
          .catch((err) => {
            this.errorLogin = true;
            this.requiredRules.push((v: string) => {
              console.error(err);
              return (
                !err.response.data.error_description || "Incorrect username or password"
              );
            });
            // this.$refs.form.validate();
            this.form;
            this.requiredRules.pop();
            this.loading = false;
            return false;
          });
      }
    } finally {
      this.loading = false;
    }
  }
}
